import {createContext} from 'preact';
import {useCallback, useContext, useEffect, useState} from 'preact/hooks'
import {onAuthStateChanged} from 'firebase/auth'
import {auth} from "../includes/firebase.js";

const AuthContext = createContext({
    user: null,
    getToken: async () => null,
    authLoading: true,
})

export function AuthProvider({children}) {
    const [user, setUser] = useState(null);
    const [authLoading, setAuthLoading] = useState(true);

    useEffect(() => {
        const unsub = onAuthStateChanged(auth, (u) => {
            setUser(u ?? null)
            setAuthLoading(false);
        })
        return unsub
    }, [])

    const getToken = useCallback(async (forceRefresh = false) => {
        if (!auth.currentUser) return null;
        // getIdToken can reject (e.g. offline refresh). Callers all handle a
        // null token already; a rejection thrown through their `await` would
        // skip the fetch chain's .finally and strand pending/loading state.
        return auth.currentUser.getIdToken(!!forceRefresh).catch(() => null);
    }, [])

    return (
        <AuthContext.Provider value={{user, getToken, authLoading}}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => useContext(AuthContext)
